import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { analyticsService } from '../services/analyticsService'

export const usePageView = (): void => {
  const location = useLocation()
  const previousPath = useRef<string | null>(null)

  useEffect(() => {
    try {
      analyticsService.track('navigation.page_view', {
        path: location.pathname,
        title: document.title,
        referrer_path: previousPath.current,
      })
    } catch {
      // Analytics must never break the app
    }

    previousPath.current = location.pathname
  }, [location.pathname])
}
